import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTranslation } from 'react-i18next';
import { useStorefrontContext } from 'context/StorefrontContext';
import { buildWhatsAppUrl } from 'utils/themeDisplay';

const WhatsAppFab: React.FC = () => {
  const { t } = useTranslation('common');
  const { theme } = useStorefrontContext();
  const href = buildWhatsAppUrl(theme?.contact?.whatsapp);

  if (!href) return null;

  return (
    <Tooltip title={t('widgets.whatsapp')}>
      <Fab
        color="success"
        aria-label={t('widgets.whatsapp')}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 88,
          zIndex: (muiTheme) => muiTheme.zIndex.snackbar,
          bgcolor: '#25D366',
          '&:hover': { bgcolor: '#1ebe57' },
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppFab;
